import React from "react";
import { View } from "react-native";

import { MarkdownText } from "components";

import {
  PoweredByImageContainer,
  PoweredByText,
  ThankYouImage,
} from "screens/main/themeB/styled";

export const PoweredByContainer = ({ style, logo, url }) => {
  return logo ? (
    <View style={style}>
      <PoweredByText>
        <MarkdownText>Powered By:</MarkdownText>
      </PoweredByText>
      <a href={url} target="_blank">
        <PoweredByImageContainer>
          <ThankYouImage source={logo} />
        </PoweredByImageContainer>
      </a>
    </View>
  ) : (
    <></>
  );
};

export default PoweredByContainer;
